import { Button } from "@heroui/button";
import { Drawer, DrawerContent, DrawerHeader, DrawerBody, DrawerFooter } from "@heroui/drawer";
import { SignOutButton } from "@clerk/clerk-react";

const LogoutDrawer = ({ show = false, onResp = () => {} }) => {
return (<>
<Drawer placement="bottom" size="sm" shouldBlockScroll hideCloseButton={false} classNames={{ backdrop: "bg-black/30" }} backdrop={"blur"} isOpen={show} onOpenChange={(isOpen) => {if (!isOpen) onResp("close", null);}}>
    <DrawerContent>
        <DrawerHeader className="flex items-center gap-3">
            <span className="font-medium">Logout</span>
        </DrawerHeader>
        <DrawerFooter className="gap-3">
            <SignOutButton>
                <Button onPress={() => {}} variant="solid" className="w-full mb-2" color="danger" >
                    Logout
                </Button>
            </SignOutButton>
        </DrawerFooter>
    </DrawerContent>
</Drawer>
</>)
}

export default LogoutDrawer